import type { BattleEngine } from '../../engine/engine';
import type { BattleCommand, CardId, CommandResult, PlayerId, WorldPoint } from '../../engine/types';

export type BattleDriverKind = 'bot' | 'replay' | 'network';

export interface BattleDriver {
  readonly kind: BattleDriverKind;
  readonly localSide: PlayerId;
  readonly allowsPause: boolean;
  readonly allowsInput: boolean;
  beforeStep(engine: BattleEngine): void;
  afterStep(engine: BattleEngine): void;
  canAdvance(engine: BattleEngine): boolean;
  submitCard(engine: BattleEngine, cardId: CardId, position: WorldPoint): CommandResult;
  debugSnapshot?(engine: BattleEngine): unknown;
  dispose(): void;
}

export function commandForCurrentTick(engine: BattleEngine, playerId: PlayerId, cardId: CardId, position: WorldPoint): BattleCommand {
  return { type: 'play-card', tick: engine.currentTick, sequence: engine.state.players[playerId].nextSequence, playerId, cardId, position };
}
